<template>
  <span class="progress-wrapper horizontal-icons">
    <b-icon v-if="submission.feePaid" icon="currency-gbp" size="is-small" title="fee paid" />
    <b-icon v-if="submission.submitted" icon="check" size="is-small" title="submitted" />
    <b-icon v-if="submission.signUp" icon="email-newsletter" size="is-small" title="Signed to the newsletter" />
    <b-icon v-if="submission.longRead" icon="book-open-variant" size="is-small" title="Long read" />
    <b-icon v-if="submission.checked" icon="eye-check-outline" size="is-small" title="checked" />
    <b-icon
      v-if="submission.marked"
      icon="map-marker-question-outline"
      size="is-small"
      title="queried"
    />
    <b-icon v-if="submission.shortlisted" icon="star" size="is-small" title="return to" />
    <b-icon
      v-if="submission.hasSelectedWork"
      icon="license"
      size="is-small"
      title="has shortlisted work(s)"
    />
  </span>
</template>
<script>
import { submissionSchema } from "../store/submission";

export default {
  name: "ProgressRow",
  props: {
    submission: {
      type: Object,
      required: true,
      default() {
        return {
          _id: "",
          ...submissionSchema
        };
      }
    }
  }
};
</script>